import React, { JSX } from "react";
import { FaFacebook, FaInstagram, FaPhone, FaWhatsapp } from "react-icons/fa";
import { SiWaze } from "react-icons/si";
import SocialPlatformEnum, { socialPlatform } from './socialTypes';

interface SocialLinkProps {
  displayName: string;
  value: string | undefined;
  type: socialPlatform;
}

const iconMap: Record<socialPlatform, JSX.Element> = {
  [SocialPlatformEnum.Facebook]: <FaFacebook className="w-7 h-7 text-blue-600" />,
  [SocialPlatformEnum.Instagram]: <FaInstagram className="w-7 h-7 text-pink-500" />,
  [SocialPlatformEnum.Waze]: <SiWaze className="w-7 h-7 text-blue-400" />,
  [SocialPlatformEnum.Whatsapp]: <FaWhatsapp className="w-7 h-7 text-green-500" />,
  [SocialPlatformEnum.Phone]: <FaPhone className="w-7 h-7 text-gray-600" />,
};

const getIcon = (type: socialPlatform) => iconMap[type] ?? null;

const SocialLink: React.FC<SocialLinkProps> = ({
  displayName,
  value,
  type,
}) => {
  if (!value) {
    return null;
  }
  return (
    <div className="flex flex-col items-center gap-1">
      <a
        href={type === "phone" ? `tel:${value}` : value}
        className="flex items-center justify-center"
        aria-label={value}
        target={value.startsWith("https://") ? "_blank" : undefined}
        rel={value.startsWith("https://") ? "noopener noreferrer" : undefined}
      >
        <span className="sr-only">{displayName}</span>
        {getIcon(type)}
      </a>
      <span className="text-sm text-center text-gray-600">{displayName}</span>
    </div>
  );
};

export default SocialLink;
